import {BACKEND_ENDPOINT} from '../../Constants'
import axiosInstance from '../../config/AxiosConfig'

export function getActiveDeviceByUser(userId) {
    return axiosInstance
        .get(`${BACKEND_ENDPOINT}/watch/getActiveDeviceByUser`, {
            params: {userId},
        })
        .then(res => (res && res?.data ? res.data : null))
}

export function getListDevices(userId, serialNumber) {
    return axiosInstance
        .get(`${BACKEND_ENDPOINT}/watch/getListDevices`, {
            params: {userId, serialNumber},
        })
        .then(res => (res && res?.data ? res.data : null))
}

export function getListApplicationCodes(userId, applicationCode) {
    return axiosInstance
        .get(`${BACKEND_ENDPOINT}/watch/getListApplicationCodes`, {
            params: {userId, applicationCode},
        })
        .then(res => (res && res?.data ? res.data : null))
}

export function activateDevice(userId, serialNumber, applicationCode) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/watch/activateDevice`, null, {
            params: {userId, serialNumber, applicationCode},
        })
        .then(res => (res && res?.data ? res.data : null))
}

export function deactivateDevice(userId, serialNumber, applicationCode) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/watch/deactivateDevice`, null, {
            params: {userId, serialNumber, applicationCode},
        })
        .then(res => (res && res?.data ? res.data : null))
}
